<template>
  <section class="decision-tree-component">
    <span class="slide-number title mb-4">
      Slide {{ activity.lesson_slide.order }}
    </span>
    <span class="title font-weight-light mb-2">
      Question
    </span>
    <p class="tab-content-description" v-html="activity.logged_question"></p>
    <span class="title font-weight-light mb-2">
      Answer
    </span>
    <v-card class="mt-3">
      <v-list three-line>
        <template v-for="(a, index) in activity.logged_answers.decisions">
          <v-list-item avatar :key="index" v-if="a.question">
            <v-list-item-avatar>
              <img
                :src="activity.logged_answers.userImageThumbnail"
                alt="avatar"
              />
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>Question {{ index }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ a.question }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item avatar :key="index" v-else-if="a.response">
            <v-list-item-avatar>
              <v-avatar :size="40" class="me-avatar white--text">
                ME
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>Answer by student</v-list-item-title>
              <v-list-item-subtitle>
                {{ a.response }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider
            v-if="index !== activity.logged_answers.decisions.length - 1"
            :key="'divider_' + index"
          />
        </template>
      </v-list>
    </v-card>
  </section>
</template>

<script>
export default {
  name: 'DecisionTree',
  props: {
    activity: {
      type: Object,
      required: true
    },
    activityIndex: {
      type: Number,
      required: true
    }
  },
  computed: {}
}
</script>

<style lang="scss">
.decision-tree-component {
  .slide-number {
    display: block;
    color: var(--v-primary-base);
  }

  .me-avatar {
    background: #ffa100;
  }
}
</style>
